import { AppointmentLicenses } from './../modules/application/types';
import { Form } from '../modules/application/types';
import ACTIONS, { FETCH_STATUS } from '../app.constants';
import { FilterCondition } from '../modules/application/types';
import { LimitAndSkipData, EventList, EventCountType } from '../modules/calendar/types';

export const getEventList = {
    pending: (data: LimitAndSkipData) => ({
        type: ACTIONS.GET_EVENT_LIST.PENDING,
        data,
        status: FETCH_STATUS.LOADING,
    }),
    success: (data: EventList, limit: number, skip: number) => ({
        type: ACTIONS.GET_EVENT_LIST.SUCCESS,
        data,
        limit,
        skip,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_EVENT_LIST.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getEventListCount = {
    pending: (data: LimitAndSkipData) => ({
        type: ACTIONS.SET_EVENT_LIST_COUNT.PENDING,
        data,
        status: FETCH_STATUS.LOADING,
    }),
    success: (eventCount: EventCountType) => ({
        type: ACTIONS.SET_EVENT_LIST_COUNT.SUCCESS,
        eventCount,
        status: FETCH_STATUS.SUCCESS,
    }),
    error: (error: Error) => ({
        type: ACTIONS.SET_EVENT_LIST_COUNT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const mergeInspectorPackDocuments = {
    pending: {
        type: ACTIONS.DOWNLOAD_INSPECTOR_PACKET.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: any) => ({
        type: ACTIONS.DOWNLOAD_INSPECTOR_PACKET.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.DOWNLOAD_INSPECTOR_PACKET.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};
export const getLinkedLicensesForAppointments = {
    pending: {
        type: ACTIONS.GET_LINKED_LICENSES_FOR_APPOINTMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (licenses: AppointmentLicenses) => ({
        type: ACTIONS.GET_LINKED_LICENSES_FOR_APPOINTMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: licenses,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_LINKED_LICENSES_FOR_APPOINTMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getFilteredLicensesForAppointment = {
    pending: {
        type: ACTIONS.GET_FILTERED_LICENSES_FOR_APPOINTMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (licenses: AppointmentLicenses) => ({
        type: ACTIONS.GET_FILTERED_LICENSES_FOR_APPOINTMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: licenses,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_FILTERED_LICENSES_FOR_APPOINTMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const addLicensesForAppointments = {
    pending: {
        type: ACTIONS.ADD_LICENSES_FOR_APPOINTMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (licenses: AppointmentLicenses) => ({
        type: ACTIONS.ADD_LICENSES_FOR_APPOINTMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: licenses,
    }),
    error: (error: Error) => ({
        type: ACTIONS.ADD_LICENSES_FOR_APPOINTMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getSpecificLicenses = {
    pending: {
        type: ACTIONS.GET_SPECIFIC_LICENSES.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (data: any) => ({
        type: ACTIONS.GET_SPECIFIC_LICENSES.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_SPECIFIC_LICENSES.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const removeLicenseFromAppointment = {
    pending: {
        type: ACTIONS.REMOVE_LICENSE_FROM_APPOINTMENT.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (licenseId: string) => ({
        type: ACTIONS.REMOVE_LICENSE_FROM_APPOINTMENT.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        payload: { licenseId },
    }),
    error: (error: Error) => ({
        type: ACTIONS.REMOVE_LICENSE_FROM_APPOINTMENT.ERROR,
        error,
        status: FETCH_STATUS.ERROR,
    }),
};

export const getEventListBegin = (data: LimitAndSkipData) => {
    return {
        type: ACTIONS.GET_EVENT_LIST_BEGIN,
        status: true,
        data,
    };
};

export const setCalendarFilterSelections = (data: Record<string, string | string[]>) => {
    return {
        type: ACTIONS.CHANGE_EVENT_FILTERS,
        payload: { data },
    };
};

export const applyEventFilters = (data: FilterCondition[], paginationData: LimitAndSkipData) => {
    return {
        type: ACTIONS.APPLY_EVENT_FILTERS,
        payload: { data },
        data: paginationData,
    };
};

export const mergeInspectorPackDocumentsBegin = (
    templateId: string,
    fileName: string,
    isInspectorPack: boolean,
    listFilters: FilterCondition[],
) => {
    return {
        type: ACTIONS.DOWNLOAD_INSPECTOR_PACKET_BEGIN,
        payload: { templateId, fileName, isInspectorPack, listFilters },
    };
};

export const getLinkedLicensesBegin = (appointmentId: string) => {
    return {
        type: ACTIONS.GET_LINKED_LICENSES_FOR_APPOINTMENT_BEGIN,
        payload: { data: appointmentId },
    };
};

export const addLicensesForAppointmentsBegin = (selectedLicenses: AppointmentLicenses, appointmentId: string) => {
    return {
        type: ACTIONS.ADD_LICENSES_FOR_APPOINTMENT_BEGIN,
        payload: { data: { selectedLicenses, appointmentId } },
    };
};

export const getFilteredLicensesForAppointmentsBegin = (personIds: string[]) => {
    return {
        type: ACTIONS.GET_FILTERED_LICENSES_FOR_APPOINTMENT_BEGIN,
        payload: { data: { personIds } },
    };
};

export const removeLicenseFromAppointmentBegin = (appointmentId: string, licenseId: string) => {
    return {
        type: ACTIONS.REMOVE_LICENSE_FROM_APPOINTMENT_BEGIN,
        payload: { data: { appointmentId, licenseId } },
    };
};

export const getCalendarSearchForm = {
    pending: {
        type: ACTIONS.GET_CALENDAR_SEARCH_FORM.PENDING,
        status: FETCH_STATUS.LOADING,
    },
    success: (searchForm: Form) => ({
        type: ACTIONS.GET_CALENDAR_SEARCH_FORM.SUCCESS,
        status: FETCH_STATUS.SUCCESS,
        data: searchForm,
    }),
    error: (error: Error) => ({
        type: ACTIONS.GET_CALENDAR_SEARCH_FORM.ERROR,
        status: FETCH_STATUS.ERROR,
        error,
    }),
};

export const getCalendarSearchConfiguredFormBegin = () => {
    return {
        type: ACTIONS.GET_CALENDAR_SEARCH_FORM_BEGIN,
    };
};
